module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"os":"Источник","name":"Тип конфигурации","cpu":"vCPU","ram":"Память","tableHead":{"name":"Имя диска","type":"Тип","size":"Размер","boot":"Загрузочный","attr":"Атрибуты","created":"Создан","config":"Конфигурация","status":"Статус","cost":"Цена","menu":"Меню"}}}')
  delete Component.options._Ctor
}
